import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import getYear from '../states/getYear';
import Redirect from '../../components/Redirect';
import PageHeading from '../../@communityshare/ui/PageHeading';
import ParentLayout from '../states/Layout';
import useNetwork from '../../hooks/useNetwork';
import { Helmet } from 'react-helmet-async';

export default function Layout(props) {
  const year = getYear(moment());
  const network = useNetwork();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>States: Redirect</title>
      </Helmet>
      <PageHeading
        breadcrumbs={['States']}
        // title="School Year"
      />
      <Redirect to={`/states/year/${year}/state/AZ`} />
    </div>
  );
}
